import React from "react";
import { useAppContext } from "../../context/appContext";
import { TextArea, Select } from "../../components/workspace";
import { Address, Contacts, Customer, FileFolder } from "../../components/JobSummary";
import PriceSummary from "../../components/ReviewForm/PriceSummary";
import JobReviewForm from "../../components/ReviewForm";
import { calcOptionTotal, calcCommissions } from "../../utils/calcOptionTotal";

function JobSummary() {
  const ADMIN_USERS = 1; // the lower the number the more privilages

  const {
    job,
    jobItems,
    options,
    fees,
    discounts,
    contacts,
    lists,
    prices,
    displayAlert,
    handleChange,
    saveRecord,
    user,
    showReviewForm,
    toggleReviewForm,
  } = useAppContext();

  // const reviewOption = reviewJob.options_id
  //   ? reviewOptions.filter((option) => option.id === reviewJob.options_id)[0]
  //   : reviewOptions[0];

  console.log("jobItems:", jobItems)
  const {
    // sales_tax: reviewOption?.sales_tax,
    grandTotal,
    jobsTotal,
    ttlPriceAdj,
    ttlCostTax,
    ttlCostMaterials,
    ttlCostLabor,
    profitTotal,
  } = calcOptionTotal({
    jobItems,
    fees,
    discounts,
    job,
    prices,
  });

  console.log("grandTotal:", grandTotal)

  const commissions = prices?.commissions?.filter(
    (row) => row.price_sheets_id === job?.price_sheets_id
  )[0];

  const { workCommission, saleCommission } = calcCommissions({
    salesReps: job?.sale_commission_ids,
    serviceReps: job?.service_commission_ids,
    profit: profitTotal,
    listServiceReps: lists.listServiceReps,
    jobType: job?.job_type_id,
    commissions,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!job.job_type_id || !job.job_status_id || !job.office_job_notes) {
      displayAlert();
      return;
    }
    saveRecord(`/core-job/update/${job.id}`, job, "job");
  };
  const handleInput = (e) => {
    const name = e.target.name;
    const value = name === "job.office_job_notes" ? e.target.value : Number(e.target.value);
    handleChange({ baseObject: job, name, value });
  };

  const reviewThisJob = (selectedJob) => {
    console.log("selectedJob:", selectedJob);

    toggleReviewForm(selectedJob);
  };

  let contactOptions = contacts
    ?.filter((cnt) => cnt.id)
    .filter((cnt) => cnt.is_active || cnt.id === job.default_contact);

  return (
    <div className="page">
      {/* ----- Job Info ------ */}
      <div className="group two-thirds">
        <form onSubmit={handleSubmit} className="form">
          <h3>Job Info</h3>
          <div className="form-center">
            <div className="one-half">
              <Select
                name="job.job_status_id"
                labelText="Job Status"
                value={job.job_status_id || "default"}
                handleChange={(e) => handleInput(e)}
                options={lists && lists.listJobStatus}
              />
            </div>
            <div className="one-half">
              <Select
                name="job.default_contact"
                labelText="Current Contact"
                value={job.default_contact}
                handleChange={(e) => handleInput(e)}
                options={contactOptions.map((cnt) => {
                  const contName = cnt.is_active
                    ? cnt.contact_name
                    : cnt.contact_name + " (Inactive)";
                  return { key: cnt.id, text: contName };
                })}
              />
            </div>
            <div className="whole">
              <TextArea
                name="job.office_job_notes"
                labelText="Job Notes"
                value={job.office_job_notes || ""}
                handleChange={(e) => handleInput(e)}
              />
            </div>
          </div>
        </form>
      </div>
      {/* ----- Address ------ */}
      <Address />
      {/* ----- Customer ------ */}
      <Customer />
      {/* ----- Contacts ------ */}
      <Contacts />
      {/* ----- File Folder ------ */}
      <FileFolder />
      {/* ----- Job Review ----- */}
      {(job.job_status_id === 15 || // In Review
        job.job_status_id === 8 || // Completed
        job.job_status_id === 9) && // Warranty Work
        user.user_roles_id <= ADMIN_USERS && (
          <div className="group whole flex-parent">
            {job.job_status_id !== 15 && (
              <PriceSummary
                grandTotal={grandTotal}
                jobsTotal={jobsTotal}
                ttlPriceAdj={ttlPriceAdj}
                ttlCostTax={ttlCostTax}
                ttlCostMaterials={ttlCostMaterials}
                ttlCostLabor={ttlCostLabor}
                profitTotal={profitTotal}
                saleCommission={saleCommission}
                workCommission={workCommission}
              />
            )}
            <div className="whole">
              <button className="btn" type="button" onClick={() => reviewThisJob(job)}>
                Review Job
              </button>
            </div>
          </div>
        )}
      {/* ----- Email/ Report Confirmation Modal ------ */}
      <div className={showReviewForm ? "show-modal modal-container" : "modal-container"}>
        <div className="group">
          <JobReviewForm />
        </div>
      </div>
    </div>
  );
}
export default JobSummary;
